import { render } from "./CloudSection.vue?vue&type=template&id=ba36b5c4&scoped=true"
import script from "./CloudSection.vue?vue&type=script&lang=js"
export * from "./CloudSection.vue?vue&type=script&lang=js"

import "./CloudSection.vue?vue&type=style&index=0&id=ba36b5c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba36b5c4"]])

export default __exports__